import ReviewModal from "./ReviewModal";

export default ReviewModal;
